type Invariant = (
  condition: unknown,
  message?: string | (() => string),
) => asserts condition;

const invariant: Invariant = (condition, message) => {
  if (condition) {
    return;
  }
  const provided = typeof message === "function" ? message() : message;
  throw new Error(
    provided ? `Invariant failed: ${provided}` : "Invariant failed",
  );
};

export { invariant };
